(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-accessories"] && !Shopify.designMode) return;
  try {
    
function initDcAccessories(root){if(root.dataset.ready)return;root.dataset.ready='true';const category=root.querySelector('[data-role="category"]'),sort=root.querySelector('[data-role="sort"]'),vendor=root.querySelector('[data-role="vendor"]'),cards=[...root.querySelectorAll('.product')],grid=root.querySelector('[data-role="grid"]');[...new Set(cards.map(c=>c.dataset.vendor).filter(Boolean))].sort((a,b)=>a.localeCompare(b)).forEach(v=>{const o=document.createElement('option');o.value=v;o.textContent=v;vendor.append(o)});function update(){let visible=0;cards.forEach(c=>{const show=(category.value==='all'||c.dataset.kind===category.value)&&(vendor.value==='all'||c.dataset.vendor===vendor.value);c.classList.toggle('hidden',!show);if(show)visible++});const ordered=[...cards];if(sort.value!=='chosen')ordered.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort.value==='low'?1:-1));ordered.forEach(c=>grid.append(c));root.querySelector('[data-role="count"]').textContent=visible+' '+root.dataset.countLabel;root.querySelector('[data-role="empty"]').classList.toggle('hidden',visible>0)}category.addEventListener('change',update);sort.addEventListener('change',update);vendor.addEventListener('change',update);root.querySelectorAll('[data-group]').forEach(a=>a.addEventListener('click',()=>{category.value=a.dataset.group;vendor.value='all';update()}));root.querySelector('[data-role="reset"]').addEventListener('click',()=>{category.value='all';vendor.value='all';sort.value='chosen';update()});root.addEventListener('shopify:block:select',()=>{category.value='all';vendor.value='all';sort.value='chosen';update()});update()}document.querySelectorAll('.dc-accessories').forEach(initDcAccessories);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.dc-accessories').forEach(initDcAccessories));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-home-sales"] && !Shopify.designMode) return;
  try {
    
function initDcHome(root){if(root.dataset.ready)return;root.dataset.ready='true';function choose(kind){root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===kind)));root.querySelectorAll('[data-kind]').forEach(c=>c.classList.toggle('hidden',kind!=='all'&&!c.dataset.kind.split(' ').includes(kind)));root.querySelector('[data-result]').textContent=root.dataset['result'+kind.charAt(0).toUpperCase()+kind.slice(1)];}root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>choose(b.dataset.filter)));root.querySelectorAll('[data-select]').forEach(a=>a.addEventListener('click',()=>choose(a.dataset.select)));}document.querySelectorAll('.dc-home').forEach(initDcHome);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.dc-home').forEach(initDcHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-product-sales"] && !Shopify.designMode) return;
  try {
    
function initSalesImages(scope){scope.querySelectorAll('.dc-sales').forEach(root=>{if(root.dataset.salesReady)return;root.dataset.salesReady='true';root.querySelectorAll('[data-sales-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.dc-sales__main-image');image.removeAttribute('srcset');image.src=button.dataset.salesImage;image.alt=button.dataset.salesAlt;}));});}initSalesImages(document);document.addEventListener('shopify:section:load',event=>initSalesImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-profitec-go"] && !Shopify.designMode) return;
  try {
    
function initGoImages(scope){scope.querySelectorAll('.dc-go').forEach(root=>{if(root.dataset.goReady)return;root.dataset.goReady='true';root.querySelectorAll('[data-go-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.go-main-image');image.removeAttribute('srcset');image.src=button.dataset.goImage;image.alt=button.dataset.goAlt;}));});}initGoImages(document);document.addEventListener('shopify:section:load',event=>initGoImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Read-more für Collection-Texte auf Mobile
  function initCollectionReadMore() {
    if (window.innerWidth >= 750) return;

    const WORD_THRESHOLD = 100;

    // Ziel-Elemente: Collection-Description (rte-formatter) + SEO-Content-Block
    const candidates = [
      ...document.querySelectorAll('rte-formatter'),
      document.querySelector('.diecrema-seo-content__inner'),
    ].filter(Boolean);

    candidates.forEach((el) => {
      const wordCount = (el.textContent || '').trim().split(/\s+/).filter((w) => w.length > 0).length;
      if (wordCount <= WORD_THRESHOLD) return;

      el.classList.add('dc-read-more');

      const btn = document.createElement('button');
      btn.className = 'dc-read-more__btn';
      btn.textContent = 'Zeig mir mehr';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('type', 'button');

      btn.addEventListener('click', () => {
        const expanded = el.classList.toggle('dc-read-more--expanded');
        btn.textContent = expanded ? 'Weniger anzeigen' : 'Zeig mir mehr';
        btn.setAttribute('aria-expanded', String(expanded));
      });

      el.insertAdjacentElement('afterend', btn);
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionReadMore);

  } catch(e) { console.error(e); }
})();
})();
